/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SelfServiceDefaultValuesForCloudstack extends models.SelfServiceDefaultValuesBase {
    getFixupPrototypeFunction() { return SelfServiceDefaultValuesForCloudstack.fixupPrototype; }

    static newInstance(model: Partial<SelfServiceDefaultValuesForCloudstack>): SelfServiceDefaultValuesForCloudstack {
        let obj = Object.assign(new SelfServiceDefaultValuesForCloudstack(), model);
        SelfServiceDefaultValuesForCloudstack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SelfServiceDefaultValuesForCloudstack>): SelfServiceDefaultValuesForCloudstack {
        if (!model) return null;
        return SelfServiceDefaultValuesForCloudstack.newInstance(<SelfServiceDefaultValuesForCloudstack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SelfServiceDefaultValuesForCloudstack) {
        if (!obj) return;

        models.SelfServiceDefaultValuesForCloudstack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SelfServiceDefaultValuesForCloudstack): boolean {
        if (models.SelfServiceDefaultValuesBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SelfServiceDefaultValuesForCloudstack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Default Network
     */
    network: string;

    /**
     * Default Zone
     */
    zone: string;

}
